import React, { Component } from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { grey } from '@material-ui/core/colors';

import OnwrMap from './OnwrMap';

// Provider
import AppProvider from '../../providers/AppProvider';

// custom theme
const theme = createTheme({
  spacing: 4,
  breakpoints: {
    xs: 0, sm: 375, md: 768, lg: 1024, xl: 1920,
  },
  palette: {
    primary: { main: '#033375', contrastText: '#fff' },
    secondary: { main: '#ff0000', contrastText: '#fff' },
    tertiary: { main: '#ff0000', contrastText: '#fff' },
    line: { main: grey[300] },
    background: {
      default: '#fff',
      grey: grey[300],
    },
  },
  typography: {
    fontFamily: [
      'Sarabun',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontKanit: [
      'Kanit',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Kanit',
    },
    h2: {
      fontFamily: 'Kanit',
    },
    h3: {
      fontFamily: 'Kanit',
    },
    h4: {
      fontFamily: 'Kanit',
    },
    h5: {
      fontFamily: 'Kanit',
    },
    h6: {
      fontFamily: 'Kanit',
    },
  },
  overrides: {
    MuiDialog: {
      paperWidthSm: {
        maxWidth: 800,
      },
    },
    MuiToolbar: {
      regular: {
        minHeight: '0px !important',
      },
    },
    MuiAlert: {
      message: {
        padding: 0,
        margin: 'auto',
      },
    },
    MuiSnackbarContent: {
      // root: {
      //   color: '#000',
      //   background: 'rgb(247 246 246 / 70%) !important',
      // },
      root: {
        backgroundColor: '#fff0',
        boxShadow: 'none',
      },
      action: {
        // marginTop: '-90px',
        marginLeft: '-50px',
      },
    },
    MuiMenuItem: {
      root: {
        fontFamily: 'Kanit',
        fontSize: '14px',
      },
    },
    MuiSelect: {
      selectMenu: {
        fontFamily: 'Kanit',
        // fontSize: '14px',
      },
    },
    MuiButton: {
      outlinedSizeSmall: {
        fontFamily: 'Kanit',
        padding: '1px 6px',
        fontSize: '14px',
        fontWeight: 'inherit',
      },
    },
    MuiInputBase: {
      input: {
        fontFamily: 'Kanit',
        // fontSize: '14px',
      },
    },
    MuiTab: {
      wrapper: {
        fontSize: '16px',
        fontWeight: 'initial',
        flexDirection: 'row',
        fontFamily: 'Kanit',
        // whiteSpace: 'nowrap',
      },
      labelIcon: {
        minHeight: 0,
      },
    },
    MuiFormControl: {
      root: {
        width: '100%',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30,
      },
    },
    MuiSvgIcon: {
      fontSizeSmall: {
        // fontSize: 14,
      },
    },
  },

});

class RootContainer extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <AppProvider>
          <OnwrMap />
        </AppProvider>
      </MuiThemeProvider>
    );
  }
}

export default RootContainer;
